import { IntroductionStatus } from "models/introduction/Introduction";
import { ProfileStatus } from "models/profile/Profile";
import { camelCaseToCapitalizedWords, snakeCaseToCapitalizedWords, toCapitalizedWords } from "utils/globalsUtils";


export enum EventType {

  //Login
  loginAttempt = "loginAttempt",
  logout = "logout",

  //Me
  profilePictureChanged = "profilePictureChanged",
  meCategoryOpened = "meCategoryOpened",
  attributeOpened = "attributeOpened",
  attributeEdited = "attributeEdited",
  attributeVisibilityChanged = "attributeVisibilityChanged",
  profileSnooze = "profileSnooze",


  //Push
  nativePushImpression = "nativePushImpression",
  nativePushClick = "nativePushClick",

  //Batch
  bContentImpression = "bContentImpression",
  bContentResponse = "bContentResponse",
  questionExtendedContentReq = "questionExtendedContentReq",
  dynamicScreenViewed = "dynamicScreenViewed",
  batchStarted = "batchStarted",
  questionnaireBack = "questionnaireBack",
  infoViewed = "infoViewed",
  // batchFinished(getBatchParams),

  //Intro
  introResponse = "introResponse",
  profileOpened = "profileOpened",
  categoryOpened = "categoryOpened",
  imageOpened = "imageOpened",
  whoFirstClicked = "whoFirstClicked",
  unmatchRequested = "unmatchRequested",

  //Chat
  chatStarted = "chatStarted",
  mediaSent = "mediaSent",
  // chatDismissed(getChatDismissedParams),

  //Contact Us
  ticketCreated = "ticketCreated",

  //General
  pageView = "pageView",


  profileCreated = "profileCreated",
  nativePushSent = "nativePushSent",
  // nativePushStateChange = "nativePushStateChange",
  // nativePushBounce = "nativePushBounce",
  introSent = "introSent",
  requestIntroduction = "requestIntroduction",
  matchServiceResponse = "matchServiceResponse",
  batchFinished = "batchFinished",
  profileStatusUpdated = "profileStatusUpdated",
  introStatusUpdated = "introStatusUpdated",
  customerSupportStatusUpdated = "customerSupportStatusUpdated",
  customerSupportMessageSent = "customerSupportMessageSent"

}

export const EventParams: Partial<Record<EventType, { value: string | number; label: string }[]>> = {
  [EventType.introStatusUpdated]: Object.values(IntroductionStatus)
    .filter(s => !isNaN(Number(s)))
  .map(s => ({
    value: s,
    label: snakeCaseToCapitalizedWords(IntroductionStatus[s])
  })),
  [EventType.profileStatusUpdated]: Object.values(ProfileStatus)
    .filter(s => !isNaN(Number(s)))
    .map(s => ({
      value: s,
      label: camelCaseToCapitalizedWords(ProfileStatus[s])
    }))
}


const eventNames: Record<string, string[]> = {
    "loginAttempt": ["provider", "mode"],
    "logout": [],
    "profilePictureChanged": ["mode"],
    "meCategoryOpened": ["categoryId"],
    "attributeOpened": ["attributeId"],
    "attributeEdited": ["attributeId"],
    "attributeVisibilityChanged": ["attributeId"],
    "profileSnooze": ["type", "reason"],
    "nativePushClick": ["eventId", "eventParam"],
    "bContentImpression": ["contentId"],
    "bContentResponse": ["contentId", "skipped"],
    "questionExtendedContentReq": ["contentId", "batchId"],
    "dynamicScreenViewed": ["infoScreenId", "type"],
    "batchStarted": ["batchName"],
    "questionnaireBack": ["questionnaireId"],
    "infoViewed": ["infoId"],
    "introResponse": ["status", "reaction", "location"],
    "profileOpened": ["r"],
    "categoryOpened": ["categoryId"],
    "imageOpened": [],
    "whoFirstClicked": ["status"],
    "unmatchRequested": [],
    "chatStarted": [],
    "mediaSent": ["mediaType"],
    "ticketCreated": ["contactUsType"],
    "pageView": ["pageName", "r"],
    "introStatusUpdated": ["status"],
    "profileStatusUpdated": ["status"],
    "customerSupportStatusUpdated": ["status"],
    "profileCreated": [],
    "nativePushSent": ["templateId"],
    "introSent": [],
    "requestIntroduction": [],
    "matchServiceResponse": [],
    "batchFinished": ["batchId"],
    "customerSupportMessageSent": []
  }
    